// Port of api/fuel/app/classes/controller/api/monty/hindex/create.php
import DB from 'offline/db'
import User from 'offline/model/user'
import HindexType from 'offline/model/hindex/type'
import { currentUser, ensureUniqueSlug, invalid, payload, persist } from './shared'

export default function(params) {
	var user = currentUser(params)
	if (!user) return invalid()

	DB.run('INSERT INTO hindex_type (user_id, hindex_official, hindex_public, hindex_name, hindex_slug, hindex_description, hindex_author, hindex_filter, hindex_users) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?)', [
		user.get_id(),
		0,
		parseInt(params.public || 0, 10) ? 1 : 0,
		params.name || '',
		ensureUniqueSlug(params.name, parseInt(params.public || 0, 10) ? 1 : 0, user.get_id()),
		params.description || '',
		user.get_name(),
		JSON.stringify(params.filter || {}),
		0
	])

	var typeId = DB.scalar('SELECT last_insert_rowid()')

	DB.run('INSERT INTO hindex_track (hindex_id, user_id, track_generated, track_hindex, track_concentration, track_bias, track_share, track_coverage, track_efficiency, track_plays) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?)', [
		typeId,
		user.get_id(),
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0
	])

	DB.run('UPDATE user SET user_count_hindex_added = user_count_hindex_added + 1 WHERE user_id = ?', [user.get_id()])
	DB.run('UPDATE hindex_type SET hindex_users = hindex_users + 1 WHERE hindex_id = ?', [typeId])

	var type = HindexType.with_id(typeId)
	var freshUser = User.with_id(user.get_id())
	return persist(payload(freshUser, type))
}
